<template>
  <PrimaryNavigation
    route-name-for-items="Contacts"
    route-name-for-edit="Addressbook"
    resource="addressbooks"
    name-item-in-query="addressbook"
    list-dispatch="addressbookStore/getList"
    list-getter="addressbookStore/getList"
    permissions-for-update="addressbook.update"
    :static-route-query="{
      contact_page: 1
    }"
    class="navigation"
    ref="navigation"
  >
    <template v-slot:footer>
      <EaseCreateFormForPrimaryNavigation
        create-dispatch="addressbookStore/create"
        list-dispatch="addressbookStore/getList"
        resource="addressbooks"
      >
      </EaseCreateFormForPrimaryNavigation>
    </template>
  </PrimaryNavigation>
</template>

<script>
import PrimaryNavigation from "../common/navigation/PrimaryNavigation";
import EaseCreateFormForPrimaryNavigation from "../common/navigation/EaseCreateFormForPrimaryNavigation";
export default {
  name: "AddressbookNavigation",
  components: {
    PrimaryNavigation,
    EaseCreateFormForPrimaryNavigation
  },
  data: function() {
    return {
      search: ""
    };
  },
  watch: {
    $route: {
      handler: function() {
        this.$refs.navigation.drawer = !this.$vuetify.breakpoint.mdAndDown;
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.navigation::v-deep .navigation-results {
  height: calc(100% - 152px);
  overflow-y: auto;
}
</style>
